import { render, staticRenderFns } from "./Rejected.vue?vue&type=template&id=eba558b0&scoped=true&"
import script from "./Rejected.vue?vue&type=script&lang=js&"
export * from "./Rejected.vue?vue&type=script&lang=js&"
import style0 from "./Rejected.vue?vue&type=style&index=0&id=eba558b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba558b0",
  null
  
)

export default component.exports